var $d87c5f1e899f6af1$exports = {};
$d87c5f1e899f6af1$exports = {
    "(optional)": `(facultatif)`,
    "(required)": `(requis)`
};


export {$d87c5f1e899f6af1$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
